"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Oops = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const oops_png_1 = __importDefault(require("./oops.png"));
const pushbutton_1 = __importDefault(require("../pushbutton"));
const oops_style_1 = __importDefault(require("./oops.style"));
const Oops = ({ classes, onHomeClick, label, description }) => (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.root }, { children: [jsx_runtime_1.jsx("img", { alt: "", src: oops_png_1.default, className: classes.icon }, void 0),
        jsx_runtime_1.jsx("p", { children: description }, void 0),
        jsx_runtime_1.jsx("div", Object.assign({ className: classes.btn }, { children: jsx_runtime_1.jsx(pushbutton_1.default, Object.assign({ primary: true, onClick: onHomeClick }, { children: label }), void 0) }), void 0)] }), void 0));
exports.Oops = Oops;
exports.Oops.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    onHomeClick: prop_types_1.default.func.isRequired,
    label: prop_types_1.default.string,
    description: prop_types_1.default.string
};
exports.Oops.defaultProps = {
    label: 'take me home',
    description: "Sorry, we can't find the page you're looking for."
};
exports.default = react_jss_1.default(oops_style_1.default)(exports.Oops);
//# sourceMappingURL=oops.js.map